/*let appID = $v('pFlowId'); //APP ID
let pageID = $v('pFlowStepId'); //APP_PAGE_ID
let sessionID = $v('pInstance'); // SESSION*/

function f_openScaleTab() {
    $("#SR_compareScalePrice_tab a").trigger("click");
}

//Compare Scenario
function f_calculateCompareScenario() {
    if (apex.region("weightScenario") !== null) {
        apex.region("weightScenario").widget().interactiveGrid("getActions").set("edit", false);
        apex.region("weightScenario").widget().interactiveGrid("getActions").invoke("save");
    }

    if (apex.region("wagonScenario") !== null) {
        apex.region("wagonScenario").widget().interactiveGrid("getActions").set("edit", false);
        apex.region("wagonScenario").widget().interactiveGrid("getActions").invoke("save");
    }

    if (apex.region("loadunitScenario") !== null) {
        apex.region("loadunitScenario").widget().interactiveGrid("getActions").set("edit", false);
        apex.region("loadunitScenario").widget().interactiveGrid("getActions").invoke("save");
    }

    setTimeout(function () {
        apex.server.process("Calculate the Scenario", {
            x01: $v('P340_REQUESTSEQ'),
            x02: $v('P340_REQUESTODSEQ'),
            x03: $v('P340_GROUPNUMBER')
        }, {
            success: function (pData) {
                console.table(pData)
                if (pData.success) {
                    if (apex.region("weightScenario") !== null) {
                        apex.region("weightScenario").refresh();
                        apex.region("weightScenarioTotal").refresh();
                    }

                    if (apex.region("wagonScenario") !== null) {
                        apex.region("wagonScenario").refresh();
                        apex.region("wagonScenarioTotal").refresh();
                    }

                    if (apex.region("loadunitScenario") !== null) {
                        apex.region("loadunitScenario").refresh();
                        apex.region("loadunitScenarioTotal").refresh();
                    }

                    apex.region("receivedOffers").refresh();
                    for (let i = 1; i <= pData.offers.length; i++) {
                        if (apex.region("weightScenario") !== null) {
                            apex.region("weightScenario").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                            apex.region("weightScenarioTotal").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                        }

                        if (apex.region("wagonScenario") !== null) {
                            apex.region("wagonScenario").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                            apex.region("wagonScenarioTotal").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                        }

                        if (apex.region("loadunitScenario") !== null) {
                            apex.region("loadunitScenario").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                            apex.region("loadunitScenarioTotal").call("getViews").grid.view$.grid("showColumn", "OFFER" + i);
                        }
                    }
                    for (let i = pData.offers.length + 1; i <= 10; i++) {
                        if (apex.region("weightScenario") !== null) {
                            apex.region("weightScenario").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                            apex.region("weightScenarioTotal").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                        }

                        if (apex.region("wagonScenario") !== null) {
                            apex.region("wagonScenario").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                            apex.region("wagonScenarioTotal").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                        }

                        if (apex.region("loadunitScenario") !== null) {
                            apex.region("loadunitScenario").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                            apex.region("loadunitScenarioTotal").call("getViews").grid.view$.grid("hideColumn", "OFFER" + i)
                        }
                    }

                    for (let i = 0; i < pData.offers.length; i++) {
                        if (apex.region("weightScenario") !== null) {
                            $("#weightScenario .a-GV-headerLabel*[id$='HDR']")[4 + i].innerHTML = pData.offers[i].companyname;
                            $("#weightScenarioTotal .a-GV-headerLabel*[id$='HDR']")[4 + i].innerHTML = pData.offers[i].companyname;
                        }

                        if (apex.region("wagonScenario") !== null) {
                            $("#wagonScenario .a-GV-headerLabel*[id$='HDR']")[3 + i].innerHTML = pData.offers[i].companyname;
                            $("#wagonScenarioTotal .a-GV-headerLabel*[id$='HDR']")[3 + i].innerHTML = pData.offers[i].companyname;
                        }

                        if (apex.region("loadunitScenario") !== null) {
                            $("#loadunitScenario .a-GV-headerLabel*[id$='HDR']")[4 + i].innerHTML = pData.offers[i].companyname;
                            $("#loadunitScenarioTotal .a-GV-headerLabel*[id$='HDR']")[4 + i].innerHTML = pData.offers[i].companyname;
                        }
                    }
                }
            }
        });
    }, 750);
};

function f_deleteScenario(p_scenariocalculatorseq) {
    if (apex.region("weightScenario") !== null) {
        apex.region("weightScenario").widget().interactiveGrid("getViews", "grid").model.clearChanges();
        apex.region("weightScenario").widget().interactiveGrid("getActions").set("edit", false);
    }

    if (apex.region("wagonScenario") !== null) {
        apex.region("wagonScenario").widget().interactiveGrid("getViews", "grid").model.clearChanges();
        apex.region("wagonScenario").widget().interactiveGrid("getActions").set("edit", false);
    }

    if (apex.region("loadunitScenario") !== null) {
        apex.region("loadunitScenario").widget().interactiveGrid("getViews", "grid").model.clearChanges();
        apex.region("loadunitScenario").widget().interactiveGrid("getActions").set("edit", false);
    }

    apex.server.process("Delete Compare Scenario", {
        x01: p_scenariocalculatorseq
    }, {
        success: function (pData) {
            if (pData.success) {
                if (apex.region("weightScenario") !== null) {
                    apex.region("weightScenario").refresh();
                    apex.region("weightScenarioTotal").refresh();
                }
                if (apex.region("wagonScenario") !== null) {
                    apex.region("wagonScenario").refresh();
                    apex.region("wagonScenarioTotal").refresh();
                }

                if (apex.region("loadunitScenario") !== null) {
                    apex.region("loadunitScenario").refresh();
                    apex.region("loadunitScenarioTotal").refresh();
                }
            } else { }
        }
    });
}

function f_providerList_users (p_provisionerseq){
    var v_requestseq   = $v('P' + pageID + '_SEQ'),
        v_requestodseq = $v('P' + pageID + '_SEQ_OD');

    var v_typeofGoods = $v('P' + pageID + '_TYPEOFGOODS');
    var arr = v_typeofGoods.split(':');
    v_typeofGoods = arr.join(';');

    apex.server.process("Get URL - Provider List Users",
        {
            x01: v_requestseq,
            x02: v_requestodseq,
            x03: p_provisionerseq,
            x04: v_typeofGoods
        }, 
        {
            success: function (pData) {
                console.log(pData);
                if ( pData.success ) {
                    apex.navigation.redirect(pData.url);
                }
            },
            error:(error)=>{
                let errmsg = error?.responseText;
                f_errorhandling(errmsg)
            }
        }
    );
}

function f_triggerAutoLogin(data){
    event.preventDefault()
  
    // We will get the key users esername and send it with the Custom DA trigger
    const username = data.triggeringElement.dataset.keyuser
    if(username != -1){
      const app = data.triggeringElement.href.includes('/sd/ru') ? 481:480
  
      const searchParams = new URLSearchParams(data.triggeringElement.href.slice(data.triggeringElement.href.indexOf('?')))
      let paramkeys = ''
      let paramvalues = ''
      for (const param of searchParams) {
          if (param[0] != 'session' && param[0] != 'cs' && param[0] != 'clear' && param[1] != ''){
              paramkeys = paramkeys + ',' + param[0]
              paramvalues = paramvalues +  ',' + param[1]
          }
      }
  
      const page = paramkeys.slice(paramkeys.indexOf('p')+1,paramkeys.indexOf('_'))
  
      const json = JSON.stringify({app,page,paramkeys,paramvalues})
  
      $.event.trigger('autoLogin',[{user:username,data:json}])
    } else{
      apex.message.alert("You can't access this offer/opportunity")
    }
  }

function f_triggerAutoLoginCustom(user,data){
    if(user != -1){
        const json = JSON.stringify(data)
        $.event.trigger('autoLogin',[{user,data:json}])
    } else{
        apex.message.alert("You can't access this offer/opportunity")
    }
}

// This function calling when cancel button clicked in odcoverage changes confirm dialog via plug-in "Simply Alert With Text Message" SMY-1292
function f_cancelOdCoverage(){
    // Supress should be true to avoid additional provider list.
    apex.item( "P" + pageId +"_ODCOVERAGE" ).setValue( "FULL", null ,true );
}

function f_subscribe_providerListIG() {
    var model  = apex.region('providerList').widget().interactiveGrid('getViews','grid').model;
    var viewId = model.subscribe( {
        onChange: function( changeType, change ) {
            //console.log(changeType);
            //console.log(change);

            if (changeType == 'set') {
                model.save();

                /* Holding */
                var fieldKey_holdingYN = model.getFieldKey('HOLDINGPROVISIONERYN');
                if (change.record[fieldKey_holdingYN] == 'Y') {
                    var fieldKey_seq = model.getFieldKey('SEQ');
                    var fieldKey_selectedYN = model.getFieldKey('SELECTEDYN');
                    f_subProviderCheck(change.record[fieldKey_seq], change.record[fieldKey_selectedYN]);
                }
            }

            // clearChanges After save...
            if (changeType == 'clearChanges') {
                apex.region("providerList").widget().interactiveGrid("getActions").set("edit", false);
                $.event.trigger('linktoSupplier_afterChange');
            }

            if (changeType == 'addData') {
                $.event.trigger('providerlist_tooltip');
            }

            if (changeType == 'refreshRecords') {
                $.event.trigger('providerlist_tooltip');
                $.event.trigger('providerList_afterSave');
            }
        }
    });
}

function f_subProviderCheck(seq, selectedYN) {
    apex.server.process("SubProvider Check", {
            x01: seq,
            x02: selectedYN
        },{
        success: function(pData) {
            if (pData.success) {
                var model  = apex.region('providerList').widget().interactiveGrid('getViews','grid').model;
                var arr_subProvider = [];

                //console.log(pData.subProviders.split(','));
                pData.subProviders.split(',').forEach( (seq) => {
                    arr_subProvider.push(model.getRecord(seq));
                });

                model.fetchRecords(arr_subProvider);
            }
        },
        error:(error)=>{
            let errmsg = error?.responseText;
            f_errorhandling(errmsg)
        }
    });
}